import api from "./api";
import endpoints from "./endpoints";

export default {
  async post(params) {
    const result = await api.post(endpoints.files.fieldHeaders.post, params);
    return result.data;
  }
};
